import Api from "../config/Axios";
// import { getZoneList } from "../../services/zone.service";


export const getListingService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/tasks/canceled-return-orders`, {params:data, ...config});
};

export const patchService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.patch(`api/web/tasks/mark-canceled-return-order-status`, data, config)
  // return Api.patch(`api/web/tasks/mark-canceled-return-order-status/force`, data, config)
};

export const patchForceService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  // return Api.patch(`api/web/tasks/mark-canceled-return-order-status`, data, config)
  return Api.patch(`api/web/tasks/mark-canceled-return-order-status/force`, data, config)
};

export const ViewImageService = (token, user_id, data) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/tasks/canceled-return-orders/view-image`, {params:data, ...config});
};
